import { FIRSTLOAD_REQUEST } from './actionTypes'

export const firstLoadRequest = (firstLoad: any) => ({
  type: FIRSTLOAD_REQUEST,
  firstLoad,
})
